<template>
    <div class="container">
        <div class="col-sm-3 col-xs-2"></div>
        <div class="col-sm-6 col-xs-8">
            <h3>Update User Information</h3>
            <hr>
            <br>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback has-feedback-left">
                        <input type="text" class="form-control" v-model="name" name="name" maxlength="150" placeholder="Full Name"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback has-feedback-left">
                        <input type="text" class="form-control" v-model="email" name="email" maxlength="120" placeholder="Email Address"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="password" class="form-control" placeholder="Password" maxlength="32" v-model="password" name="password"/>
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="password" class="form-control" placeholder="Verify Password" maxlength="32" v-model="verifyPassword" name="verifyPassword" />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-xs-12"><button class="btn btn-primary" @click="updateAccount">Update Account</button></div>
            </div>
        </div>
        <div class="col-sm-3 col-xs-2"></div>
    </div>
</template>

<script>
  import swal from 'sweetalert2'
  import axios from 'axios'

  export default {
    name: 'user-maintenance-page',
    data () {
      return {
        name: '',
        password: '',
        verifyPassword: '',
        email: ''
      }
    },
    methods: {
      updateAccount () {
        let emailRegex = RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')

        if (this.email.trim().length !== 0 && emailRegex.test(this.email.trim()) === false) {
          swal('Please enter a valid Email')
          return
        }
        if (this.password.trim().length !== 0 && this.password.trim().length < 6) {
          swal('Please enter a Password that is at least 6 characters long.')
          return
        }
        if (this.password.trim().length !== 0 && this.verifyPassword !== this.password) {
          swal('Please verify your password')
          return
        }
        if (this.name.trim().length !== 0 && this.name.trim().length < 2) {
          swal('Please enter a name longer than 2 characters ')
          return
        }
        axios.post('./static/api/Ajax.php', {
          Name: this.name.trim(),
          Password: this.password.trim(),
          VerifyPassword: this.verifyPassword.trim(),
          Email: this.email.trim(),
          action: 'Update Account'
        }).then((response) => {
          if (response.data.status === 'success') {
            swal('Your account was successfully updated.')
          } else {
            swal(response.data.status)
          }
        }).catch((e) => {
          console.log(e)
        })
      }
    },
    mounted () {
      if (this.$store.getters.getUserHome() === 'username') {
        window.location = './#/search'
      }

      axios.post('./static/api/Ajax.php', {
        action: 'Get User Info'
      }).then(response => {
        if (response.data.status === 'success') {
          this.name = response.data.name
          this.email = response.data.email
        } else {
          swal(response.data.status)
        }
      })
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/userMaintenancePage.vue